import React from "react";

const paragraph = {
    fontSize: "1.2em",
    marginBottom: "1.5em"
};

const AWGPrePaymentNotice = () => (
    <div
        style={{
            lineHeight: 1.3
        }}
    >
        <h2
            style={{
                ...paragraph,
                fontSize: "22px",
                color: "#D75094",
                fontWeight: 600,
                lineHeight: 1.2,
                marginBottom: "3ex"
            }}
        >
            Important Information: Collection of £50 excess
        </h2>

        <p
            style={{
                ...paragraph,
                marginBottom: "1em"
            }}
        >
            Before you access IPRS Health services on behalf of Alliance Health
            Group, we need to collect and validate a payment card.
        </p>

        <p
            style={{
                ...paragraph,
                fontWeight: 600,
                marginBottom: "1em"
            }}
        >
            Payment card details are taken in case IPRS Health needs to collect
            an excess on your policy.
        </p>

        <p style={paragraph}>
            A £50 excess applies per person, per policy year. This means each
            member is responsible for the first £50 of eligible treatment costs
            incurred during a Scheme year.
        </p>

        <p style={paragraph}>
            The excess is payable once, per person, in each Scheme year and will
            be applied to the first paid invoice of the Scheme year. Once the
            excess has been met, further eligible claims for that person will be
            covered in accordance with the Scheme rules and benefits. The excess
            only applies to treatment that has been approved under the Scheme.
            Any treatment or services that are not covered will remain the
            responsibility of the member. For further information about how the
            excess applies, please contact Alliance Health Group before arranging
            treatment.
        </p>

        <p style={paragraph}>
            To streamline your service, we would like to validate a payment
            card, that we will hold securely and only use if your excess is due.
            To validate your card a £1 validation transaction will be processed,
            however, this will be refunded back to your card, by IPRS Health.
        </p>

        <p style={paragraph}>
            If IPRS Health do debit your card, we always provide you with 5
            working days' notice, by email.
        </p>

        <p style={paragraph}>
            Please provide the card details below that you would like IPRS
            Health to validate.
        </p>
    </div>
);

export default AWGPrePaymentNotice;
